import { createUseStyles } from 'react-jss'

export default createUseStyles({
  root: {
    display: 'block',
    width: '100%',
  },
  bookingForOtherOption: {
    gridColumnStart: 2,
    gridColumnEnd: 4,
  },
})
